import {ID, Response} from '../../../../../../_metronic/helpers'
import {FormikProps} from 'formik'
import {Tag} from '../../../../../../_metronic/partials/modals/task/core/_models'
import {UserModel} from '../../../../auth'

interface IconUserModel {
  user_id: ID
  name: string
  avatar?: string
  color?: string
  initials?: string
  task_responsible_id: ID
}

export type TaskPriorityOption = {label: string; value: string}

export const taskPriorityOptions: Array<TaskPriorityOption> = [
  {label: 'Baixa', value: 'baixa'},
  {label: 'Média', value: 'media'},
  {label: 'Alta', value: 'alta'},
  {label: 'Crítica', value: 'critica'},
]

export type TaskDateWorkEntry = {
  created_at: string
  date_format: string
  total_time?: number
  output?: string
  user_id?: number
  user_name?: string
}

export type Task = {
  id?: number
  // Só na clonagem: id da tarefa de origem.
  task_id?: number
  name?: string
  status?: string
  color?: string
  creator_id?: string
  creator_name?: string
  total_tasks?: number
  project_id?: string
  project_name?: string
  users?: Array<IconUserModel>
  usersAll?: Array<IconUserModel>
  description?: string
  begin_date?: string
  expected_date?: string
  total_time?: number
  play?: string
  id_file?: ID
  file_name?: string
  file_src?: string
  dates_work?: TaskDateWorkEntry[]
  /** Gestor/admin: uma linha por usuário e dia; omitido para demais usuários. */
  dates_work_all_users?: TaskDateWorkEntry[] | null
  total_time_format?: string
  created_at?: string
  file?: Array<any>
  checklist_concluded?: Array<any>
  checklist_name?: Array<any>
  sprintId?: ID
  order?: number
  comments?: Comment[]
  tags: Tag[]
  sequence_responsibles?: UserModel[]
  priority?: string
  end_date?: string
  task_checklists_count?: number
  task_checklists_concluded_count?: number
  task_attachement_count?: number
  tags_count?: number
  has_active_play?: boolean
  subtasks_count?: number
  updated_at?: string
  project_stage?: {
    id?: number
    name?: string
    color?: string
  }
  sprint_id?: number | null
  sprint_name?: string | null
  sprints?: Array<{sprint_id: number; sprint_name: string}>
  parent_id?: number | null
  subtasks?: Task[]
  salesforce_task_id?: string | null
  salesforce_catalog_id?: number | string | null
  salesforce_case_solution?: string | null
}

export type Comment = {
  // id: number
  // user_id: number
  // description: string
  // user_name: string
  // user_avatar: string
  // created_at: Date
  id?: ID
  event?: string
  project_id?: number
  user_id?: ID
  user?: {id: number; name: string; avatar: string | null}
  when?: Date
  auditable_type?: string
  auditable_id?: number
  details?: {
    old: {[key: string]: any}
    new: {[key: string]: any}
    period?: string
    play?: boolean
    total_time?: number
    user_id?: string
    user_name?: string

  }
  content?: string
  content_plain?: string
  mentions?: number[]
  attachments?: string[]
  created_at?: Date
  user_name?: string
}

export type TaskKanban = Task & {
  id: number | string
}

export type ResponseTask = {
  tasks: Task
  message?: string
  errors?: boolean
  status?: string
}

export type TasksQueryResponse = Response<Array<Task>>

export const initialTask: Task = {
  name: '',
  description: '',
  status: 'Backlog',
  project_id: '',
  project_name: '',
  creator_id: '',
  expected_date: '',
  file: [],
  checklist_concluded: [],
  checklist_name: [],
  users: [],
  usersAll: [],
  tags: [],
  priority: undefined,
}

export type Board = {
  [id: string]: Task[]
}

export type StepProps = {
  data: Task
  updateData: (fieldsToUpdate: Partial<Task>) => void
  hasError: boolean
  props?: FormikProps<Task>
}
